export default "__VITE_ASSET__BGuTPJEH__"